import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL || 'https://demo.supabase.co';
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY || 'demo-key';

// Create a mock supabase client for development
const createMockSupabase = () => ({
  auth: {
    getSession: () => Promise.resolve({ data: { session: null }, error: null }),
    onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } }),
    signInWithPassword: () => Promise.resolve({ data: { user: null }, error: { message: 'Mock authentication' } }),
    signOut: () => Promise.resolve({ error: null }),
    updateUser: () => Promise.resolve({ data: { user: null }, error: null }),
  },
  from: (table) => ({
    select: (columns = '*') => {
      const chainable = {
        eq: (column, value) => chainable,
        lt: (column, value) => chainable,
        filter: (column, operator, value) => chainable,
        single: () => Promise.resolve({ data: null, error: null }),
        then: (callback) => Promise.resolve(callback({ data: null, error: null }))
      };
      return chainable;
    },
    insert: (data) => Promise.resolve({ data: null, error: null }),
    update: (data) => ({
      eq: (column, value) => Promise.resolve({ data: null, error: null })
    }),
    delete: () => ({
      eq: (column, value) => Promise.resolve({ data: null, error: null })
    }),
  }),
  channel: (name) => ({
    on: (event, filter, callback) => ({
      subscribe: () => ({ unsubscribe: () => {} })
    }),
    subscribe: () => ({ unsubscribe: () => {} })
  }),
  removeChannel: () => {},
});

// Use mock client if environment variables are missing
const isDemoMode = !import.meta.env?.VITE_SUPABASE_URL || !import.meta.env?.VITE_SUPABASE_ANON_KEY;

export const supabase = isDemoMode ? createMockSupabase() : createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
  }
});
